'use client';
import { LoaderService } from '@capsicum/common';
import { motion } from 'framer-motion';
import { useAtomValue } from 'jotai';
import { type FC } from 'react';
import styled from 'styled-components';

export const LoaderWrapper: FC<{ testID?: string }> = ({ testID }) => {
	const loaderCount = useAtomValue(LoaderService.count);
	const LoaderContent = useAtomValue(LoaderService.content);

	return loaderCount > 0 ? (
		LoaderContent ? (
			<LoaderContent />
		) : (
			<>
				<S.Container animate={{ opacity: 1 }} as={motion.div} initial={{ opacity: 0 }}></S.Container>
				<S.Wrapper data-testid={testID}>
					<motion.div
						animate={{
							borderRadius: ['20%', '20%', '50%', '50%', '20%'],
							rotate: [0, 0, 270, 270, 0],
							scale: [1, 2, 2, 1, 1]
						}}
						style={{
							background: 'white',
							height: 100,
							width: 100
						}}
						transition={{
							duration: 2,
							ease: 'easeInOut',
							repeat: Infinity,
							repeatDelay: 1,
							times: [0, 0.2, 0.5, 0.8, 1]
						}}
					/>
				</S.Wrapper>
			</>
		)
	) : null;
};

namespace S {
	export const Wrapper = styled.div`
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 2;
	`;

	export const Container = styled(Wrapper)`
		background: rgba(0, 22, 37, 0.8);
		backdrop-filter: blur(8px);
	`;
}
